exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-move[data-v-3a5f3b8a] .el-tabs__nav-wrap::after{height:0}.tab-move[data-v-3a5f3b8a] .el-tabs__header{margin:0}.tab-move[data-v-3a5f3b8a] .el-tabs__active-bar{height:0}.tab-move[data-v-3a5f3b8a] .el-tabs__item{padding-bottom:15px;height:0;line-height:0}[data-v-3a5f3b8a] .el-tabs__item.is-active{color:#303133;font-weight:600}.tree-box[data-v-3a5f3b8a]{height:340px}.tree-box[data-v-3a5f3b8a] .el-scrollbar__wrap{overflow-x:hidden}.iconfont[data-v-3a5f3b8a]{font-size:13px}.el-icon-s-home[data-v-3a5f3b8a]{color:#ffca28;font-size:14px}\n", ""]);

// exports
